import { defineMessages } from 'react-intl';

export const backupExtractionFailedMessages = defineMessages({
  title: {
    defaultMessage: "Couldn't back up your recording",
    id: 'jNORH8qJWQ',
    description:
      'Toast title when the local backup of earlier audio fails and no other prompt covers it',
  },
  description: {
    defaultMessage:
      'We could not save a backup of the earlier audio, so part of it may not be recoverable.',
    id: '6C3+Vk6GLR',
    description:
      'Toast description when the local backup of earlier audio fails before a new recording starts',
  },
});
